<script>
  import { getRandomInt } from '../../Common/tools';
  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';
  import { showSettingsPopup } from '../service/LmsUIService';
  import RequestAccessEditQuestion from './RequestAccessEditQuestion.svelte';

  export let circle, onChange;

  let sortable, jqSortable;

  let requestAccess = circle.settings.requestAccess;
  let title = requestAccess.title;
  let description = requestAccess.description;
  let questions = requestAccess.questions;

  function addQuestion() {
    const newQuestion = {
      id: `q_${getRandomInt()}`,
      type: 'text',
      label: M.NEW_QUESTION,
      required: true,
      options: []
    };

    questions = [...questions, newQuestion];
    onChange({ ...requestAccess, questions });
    editQuestion(newQuestion);
  }

  function deleteQuestion(id) {
    questions = questions.filter((q) => q.id !== id);
    onChange({ ...requestAccess, questions });
  }

  function updateQuestion(id, field, value) {
    questions = questions.map((q) => {
      if (q.id === id) {
        // reset options if we're changing type
        if (field === 'type' && !['select', 'radio', 'checkbox'].includes(value)) {
          q = { ...q, options: [] };
        }
        return { ...q, [field]: value };
      }
      return q;
    });

    onChange({ ...requestAccess, questions });
  }

  function editQuestion(question) {
    showSettingsPopup({
      width: 420,
      component: (target, close) =>
        new RequestAccessEditQuestion({
          target: target,
          props: {
            question: question,
            updateQuestion: updateQuestion,
            deleteQuestion: deleteQuestion,
            closePopup: close
          }
        })
    });
  }

  onMount(() => {
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: '.option-item',
      handle: '.move-icon',
      containment: 'parent',
      tolerance: 'pointer',
      axis: 'y',
      start: (event, ui) => {
        ui.item.data('idx', ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data('idx') || 0;
        debugger;
        if (newIdx !== oldIdx) {
          let elem = questions[oldIdx];
          questions.splice(oldIdx, 1);
          questions.splice(newIdx, 0, elem);
          questions = questions;
          onChange({ ...requestAccess, questions });
        }
      }
    });
  });

  onDestroy(() => {
    jqSortable.sortable('destroy');
    jqSortable = null;
  });
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon">app_registration</span>
  </div>
  <h4 class="col20 f-left mt-15 mb-15 t-center h4-bigger">{M.ACCESS_REQUEST_QUESTIONNARIE}</h4>
  <span class="light-gray-text t-center col20 f-left mb-25">{M.ACCESS_REQUEST_QUESTIONNARIE_DESC}</span>

  <div class="popup-input-wrapper">
    <h5>{M.QUESTIONNARIE_TITLE}</h5>
    <input
      type="text"
      bind:value={title}
      on:input={() => {
        onChange({ ...requestAccess, title });
      }}
      placeholder={M.QUESTIONNARIE_TITLE_PLACEHOLDER} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.QUESTIONNARIE_DESCRIPTION}</h5>
    <input
      type="text"
      bind:value={description}
      on:input={() => {
        onChange({ ...requestAccess, description });
      }}
      placeholder={M.QUESTIONNARIE_DESCRIPTION_PLACEHOLDER} />
  </div>
  <div class="col20 f-left t-center">
    <a on:click={addQuestion} class="middle-button blue with-icon inline-block f-none">{M.ADD_QUESTION}</a>
  </div>
  <div class="form-admin-style-2 col20 f-left">
    <div bind:this={sortable} class="ui-sortable form-wrapper col20 f-left">
      {#each questions as question, index (index + question.id)}
        <div class="option-item field field-type-text">
          <span
            class="move-icon button-tooltip ui-sortable-handle"
            data-tooltip="simpleMove"
            data-original-title=""
            title=""></span>
          <input
            type="text"
            bind:value={question.label}
            on:input={() => {
              updateQuestion(question.id, 'label', question.label);
            }}
            placeholder="Enter question title"
            class="label-field modify" />
          <div class="buttons-wrapper flex-none">
            <a
              on:click={() => editQuestion(question)}
              data-tooltip="simpleEdit"
              class="edit light-gray-icon modify button-tooltip circle-effect"
              data-original-title=""
              title=""><i class="material-icons-outlined">edit</i></a>
            <a
              on:click={() => {
                deleteQuestion(question.id);
              }}
              data-tooltip="simpleDelete"
              class="delete delete-icon light-gray-icon modify button-tooltip mr-10 circle-effect"
              ><i class="material-icons-outlined">delete</i></a>
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>
